// extracted by mini-css-extract-plugin
export default {"TeaserVid":"styles_TeaserVid__HI+fS","TeaserVidOverlay":"styles_TeaserVidOverlay__LT9ez"};